import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../../environments/urlService';
import { catchError, map } from 'rxjs/operators';
import { IGNORE_ERROR_HANDLING } from '../../../../util/interceptors';
import {
  MetricGroupsAndPeriods,
  MetricsForExternalUsers,
  MetricUploadByExternalUser,
  MetricUploadPasswordWrapper,
} from '../../dto/MetricGroupsAndPeriods';
import { MetricSharedLinkRelatedInfo, MetricSharedLinkWrapper } from '../../dto/MetricSharedLinkWrapper';

@Injectable({
  providedIn: 'root',
})
export class MetricSharedLinkService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'metrics/shared-link';
  }

  saveRequestedData(companyUUID: string, wrapper: MetricUploadByExternalUser): Observable<void> {
    return this.http.put<void>(
      this.url + '/external', wrapper,
      {
        params: { companyUUID },
        withCredentials: true,
      },
    );
  }

  get(companyUUID: string): Observable<MetricSharedLinkWrapper> {
    return this.http.get<MetricSharedLinkWrapper>(
      this.url,
      {
        context: new HttpContext().set(IGNORE_ERROR_HANDLING, true),
        params: { companyUUID },
        withCredentials: true,
      },
    ).pipe(catchError(() => of(null)));
  }

  getRelatedInfo(token: string): Observable<MetricSharedLinkRelatedInfo> {
    return this.http.get<MetricSharedLinkRelatedInfo>(
      this.url + '/external',
      {
        params: { token },
      },
    );
  }

  getByPassword(dto: MetricUploadPasswordWrapper): Observable<MetricsForExternalUsers> {
    return this.http.post<MetricsForExternalUsers>(
      this.url + '/external/by-password',
      dto,
    ).pipe(map(
      (responseDto) => {
        const deserialized = MetricGroupsAndPeriods.deserializeMetricGroupsAndPeriods(responseDto) as MetricsForExternalUsers;
        deserialized.contact = responseDto.contact;
        return deserialized;
      },
    ));
  }

  create(wrapper: MetricSharedLinkWrapper): Observable<MetricSharedLinkWrapper> {
    return this.http.post<MetricSharedLinkWrapper>(
      this.url,
      wrapper,
      {
        withCredentials: true,
      },
    );
  }

  update(wrapper: MetricSharedLinkWrapper): Observable<void> {
    return this.http.put<void>(
      this.url,
      wrapper,
      {
        withCredentials: true,
      },
    );
  }

  delete(linkUUID: string): Observable<void> {
    return this.http.delete<void>(
      this.url,
      {
        params: { linkUUID },
        withCredentials: true,
      },
    );
  }
}
